import { render, staticRenderFns } from "./Achat.vue?vue&type=template&id=71719272&"
import script from "./Achat.vue?vue&type=script&lang=ts&"
export * from "./Achat.vue?vue&type=script&lang=ts&"
import style0 from "./Achat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports